module.exports = __webpack_public_path__ + "img/beer_id-97.9a74d18b.png";